import React from "react";
import "./userImage.css";

const UserImage = ({ data }) => {
  return (
    <div className={"user-image"}>
      <div className={"circle-image"}>
        <img
          src={process.env.PUBLIC_URL + "/teamPhotos/" + data.img + "@1x.jpg"}
          srcSet={
            process.env.PUBLIC_URL +
            "/teamPhotos/" +
            data.img +
            "@1x.jpg, " +
            (process.env.PUBLIC_URL + "/teamPhotos/" + data.img + "@2x.jpg 2x")
          }
          alt={"Picture of dark employee: " + data.name}
        />
      </div>
      <h1
        className={"small-title dark-purple-text MankSans-Medium center-text"}
      >
        {data.name}{" "}
        <p
          className={
            "extra-sm-text dark-purple-text MankSans-Medium center-text"
          }
        >
          ({data.pronoun})
        </p>
      </h1>
      <p className={"paragraph-text"}>{data.title}</p>
    </div>
  );
};

export default UserImage;
